 import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { useForm } from 'antd/lib/form/Form';
import {
  Form,
  Row,
  notification,
  DatePicker,
  Spin,
  Tag,
  Tabs,
  Card,
  Col,
  Input
} from 'antd';

import DF from 'DisplayFramework';
import { shouldUpdateCompare } from 'utils/utils2';
import {
  createBroker,
  getBrokerByAssocID,
  getMyBrokerProfile,
  MgBroker,
  MgBrokerResponse,
  updateBroker,
} from 'services/parametersService';
import FormInput from 'components/FormInput';
import SaveButton from 'components/SaveButtonTabsTop';
import MgCompanyList from 'components/MgCompanyList';
import ParListSelect from 'components/ParListSelect';
// import EnableDisableBrokerButton from './EnableDisableBrokerButton';
import BrokerVendorsTab from './BrokerVendorsTab';
import { BrokerForProposalType } from 'components/BrokerInput';
import { isNil } from 'lodash';
import { ArrowLeftOutlined } from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import EnableDisableBrokerButton from './EnableDisableBrokerButton';


const { TabPane } = Tabs;

type MgBrokerWithSearch = MgBroker & {
  broker: { tpname: string; tpid: number };
};

type BrokerDetailProps = {
  associdbroker?: number;
  isCreate?: boolean;
  brokerMgid?: number;
  close?: () => void;
  refetchBrokerList?: () => void;
  setBrokerForProposal?: (BrokerForProposal: BrokerForProposalType) => void;
  hideBrokerModal?: () => void;
  hideBrokerSearchModal?: () => void;
  showAsModal?: boolean;
  modal?: boolean;
  tpidbroker?: any;
  setData?: (item: MgBrokerResponse) => void;
};

const BrokerDetail = (props: BrokerDetailProps) => {
  const {
    isCreate,
    brokerMgid,
    refetchBrokerList,
    modal,
    associdbroker,
    showAsModal,
    setData,
  } = props;
  const [form] = useForm();
  const history = useHistory();
  const { mgid: paramsMgid, associdOrCreate } = useParams<{
    mgid: string;
    associdOrCreate: string;
  }>();
  const mgid = Number(
    brokerMgid
      ? brokerMgid
      : paramsMgid
      ? paramsMgid
      : localStorage.getItem('mgid') ?? 0
  );
  const isMyprofile =
    associdbroker || isCreate
      ? false
      : associdOrCreate === undefined
      ? true
      : associdOrCreate === 'create' || brokerMgid !== null
      ? false
      : true;
  const isCreatelocal = isCreate || associdOrCreate === 'create';
  const associd = !isCreatelocal
    ? associdOrCreate
      ? Number(associdOrCreate)
      : associdbroker
    : associdbroker;
  const [associdState, setAssocidState] = useState(associd);

  // Sync associdState with associd from URL when it changes
  useEffect(() => {
    if (associd && associd !== associdState) {
      setAssocidState(associd);
    }
  }, [associd]);

  const {
    data: brokerDetail,
    refetch,
    isFetching,
  } = useBrokerDetail(Number(associd), isMyprofile,isCreatelocal);

  const submit = (values: MgBrokerWithSearch) => {
    const brokerRequest: MgBroker = {
      associd: values.associd,
      brokerstatus: 'INIT',
      enddate: values.enddate
        ? moment(values.enddate).format('YYYY-MM-DD')
        : '',
      mgid: Number(mgid),
      networkcode: values.networkcode,
      tprole: values.tprole,
      startdate:
        values.startdate && moment(values.startdate).format('YYYY-MM-DD'),
      // tpidbroker: Number(form.getFieldValue('tpidbroker')),
      tpname: form.getFieldValue('tpname'),
      tpreference: form.getFieldValue('tpreference'),
      motif: form.getFieldValue('motif'),
      pvalexige: form.getFieldValue('pvalexige'),


    };

    // if (
    //   values.enddate &&
    //   values.enddate.length !== 0 &&
    //   values.startdate > values.enddate
    // ) {
    //   // notification.error({
    //   //   message: 'the start date must be less than the end date',
    //   // });
    // } else {
      if (isNil(associdState)) {
        createBroker({brokerRequest })
          .then((response) => {
            if (response.code === '200') {
              notification.success({
                message: response.message,
              });
              console.log("modal", modal);
              if (!modal) {
                history.push(
                  `/configuration/management-company/${mgid}/broker/${response.data.associd}`
                );
              } else {
                setAssocidState(response.data.associd);
                refetchBrokerList && refetchBrokerList();
              }
              setData && setData(response.data);
            }
            // Error notifications are handled globally in request.ts
          })
          .catch(() => {
            // Error notifications are handled globally in request.ts
          });
      } else {
        updateBroker({
          brokerRequest: brokerRequest,
          associd: Number(associdState),
        })
          .then((response) => {
            if (response.code === '200') {
              notification.success({
                message: response.message,
              });
              refetch();
              refetchBrokerList && refetchBrokerList();
            }
            // Error notifications are handled globally in request.ts
          })
          .catch(() => {
            // Error notifications are handled globally in request.ts
          });
      }
    // }
    // if (brokerMgid && refetchBrokerList && close) {
    //   refetchBrokerList();
    //   close();
    // }
  };

  useEffect(() => {
    if (brokerDetail) {
      form.setFieldsValue({
        ...brokerDetail,
        enddate: brokerDetail.enddate ? moment(brokerDetail.enddate) : null,
        startdate: brokerDetail.startdate && moment(brokerDetail.startdate),
        brokerstatus: brokerDetail.brokerstatus,
        tprole: brokerDetail.tprole,
        tpreference: brokerDetail.brokerreference,
        tpidbroker: brokerDetail.tpidbroker,
        tpname: brokerDetail.brokername,
      
        mgid:mgid
      });
    } else if (isCreatelocal) {
      form.setFieldsValue({ startdate: moment(), brokerstatus: 'INIT', mgid: mgid });
    }
  }, [form, brokerDetail, mgid, isCreatelocal]);

  return (
    <DF.Provider pagcode="brokerdetail">
      <Spin spinning={false}>
        <Form
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={submit}
          labelAlign="left"
          initialValues={{ mgid: mgid }}
        >
          <div className="card-container">
            <Tabs
              defaultActiveKey="1"
              type="card"
              tabBarExtraContent={
                !isMyprofile && (
                  <Row>
                    <Form.Item
                      noStyle
                      shouldUpdate={shouldUpdateCompare('brokerstatus')}
                    >
                      {({ getFieldValue }) => (
                        <EnableDisableBrokerButton
                          mgid={Number(mgid)}
                          associd={Number(associdState)}
                          statusToUpdate={getFieldValue('brokerstatus')}
                          refetch={refetch}
                          disabled={isNil(associdState)}
                        />
                      )}
                    </Form.Item>
                    <SaveButton
                      comcode={isNil(associdState) ? 'save' : 'update'}
                    />
                  </Row>
                )
              }
            >
              <TabPane
                tab={
                  <>
                    <ArrowLeftOutlined
                      onClick={() => {
                        history.push(
                          `/configuration/management-company/brokers`
                        );
                      }}
                      hidden={associdbroker ? true : undefined}
                    />
                    <GetLabel label="BrokerDetail" />
                  </>
                }
                style={{
                  borderColor: 'transparent',
                }}
              >
                <Card>
                  <Row gutter={20} style={{ padding: 8 }}>
  {/* First Row */}
  <Col xs={24} lg={12} xl={8}>
    <FormInput rules={[{ required: true }]} name="tpreference">
      <Input maxLength={30} />
    </FormInput>
  </Col>
  
  {/* <Col xs={24} lg={12} xl={8}>
    <FormInput
      rules={[
        { required: true },
        { 
          pattern: /^[0-9]*$/,
          message: 'Please enter numbers only'
        }
      ]}
      name="tpidbroker"
    >
    </FormInput>
  </Col> */}
  
  <Col xs={24} lg={12} xl={8}>
    <FormInput rules={[{ required: true }]} name="tpname">
      <Input maxLength={100} />
    </FormInput>
  </Col>

  {/* Second Row */}
  <Col xs={24} lg={12} xl={8}>
    <FormInput
      name="mgid"
      hidden={modal}
      rules={[{ required: true }]}
    >
      <MgCompanyList disabled={modal}/>
    </FormInput>
  </Col>
  
  <Col xs={24} lg={12} xl={8}>
    <FormInput rules={[{ required: true }]} name="tprole">
      <ParListSelect parcode="BRROLE" disabled={isMyprofile} />
    </FormInput>
  </Col>
  
  <Col xs={24} lg={12} xl={8}>
    <FormInput rules={[{ required: true }]} name="networkcode">
      <ParListSelect parcode="DIRECTION" disabled={isMyprofile} />
    </FormInput>
  </Col>

  {/* Third Row */}
  <Col xs={24} lg={12} xl={8}>
    <FormInput name="startdate">
      <DatePicker
        defaultValue={moment(new Date(), 'YYYY-MM-DD')}
        name="startdate"
      />
    </FormInput>
  </Col>
  
  <Col xs={24} lg={12} xl={8}>
    <FormInput name="enddate">
      <DatePicker />
    </FormInput>
  </Col>
  
  <Col xs={24} lg={12} xl={8}>
    <FormInput name="brokerstatus">
      <Form.Item noStyle shouldUpdate={shouldUpdateCompare('brokerstatus')}>
        {({ getFieldValue }) => (
          <Tag
            color={
              getFieldValue('brokerstatus') === 'ACTIVE'
                ? 'success'
                : getFieldValue('brokerstatus') === 'DISABLED'
                ? 'error'
                : 'default'
            }
          >
            {getFieldValue('brokerstatus')}
          </Tag>
        )}
      </Form.Item>
    </FormInput>
  </Col>

  {/* Fourth Row (2 items) */}
  <Col xs={24} lg={12} xl={8}>
    <FormInput name="pvalexige">
      <Input maxLength={300} />
    </FormInput>
  </Col>
  
  <Col xs={24} lg={12} xl={8}>
    <FormInput name="motif">
      <ParListSelect parcode="BRMOTIF" />
    </FormInput>
  </Col>
</Row>

                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare('broker')}
                  >
                    {({ getFieldValue }) => (
                      <BrokerVendorsTab
                        mgid={Number(mgid)}
                        tpidbroker={
                          getFieldValue('tpidbroker') ||
                          getFieldValue('broker')?.tpid
                        }
                        associdState={isNil(associdState) ? true : false}
                      />
                    )}
                  </Form.Item>
                </Card>
              </TabPane>
              
            </Tabs>
          </div>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

const useBrokerDetail = (
  associd: number,
  isMyprofile: boolean,
  isCreate: boolean 
) => {
  const MyBrokerProfile = useQuery(
    ['getMyBrokerProfile'],
    () =>
      getMyBrokerProfile({ associd: 0 }).then(
        (res) => res.data
      ),
    {
      enabled: isMyprofile,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const brokerDetail = useQuery(
    ['getBrokerByAssocID', {associd }],
    () =>
      getBrokerByAssocID({
        associd: associd,
      }).then((res) => res.data),
    {
      enabled: associd !== 0 && !isMyprofile && !isCreate,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );
  return isMyprofile ? MyBrokerProfile : brokerDetail;
};
export default BrokerDetail;